// removed by extract-text-webpack-plugin
module.exports = {"select":"src-components-sitewide-Filter-__build-filter__select--1_vEq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/sitewide/Filter/build-filter.css
// module id = 1996
// module chunks = 0